






























import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { TranslateResult } from 'vue-i18n'

@Component
export default class AppButton extends Vue {
  @Prop({ type: String, default: '' }) readonly label!: string
  @Prop({ default: 'blue' }) readonly theme!: string
  @Prop({ type: Boolean, default: false }) readonly bold!: boolean
  @Prop({ type: Boolean, default: false }) readonly shadow!: boolean
  @Prop({ type: Boolean, default: false }) readonly block!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: Boolean, default: false }) readonly xLarge!: boolean
  @Prop({ type: Boolean, default: false }) readonly large!: boolean
  @Prop({ type: Boolean, default: false }) readonly small!: boolean
  @Prop({ type: Boolean, default: false }) readonly xSmall!: boolean
  @Prop({ type: Boolean, default: false }) readonly outlined!: boolean
  @Prop({ type: Boolean, default: false }) readonly noEffect!: boolean
  @Prop({ type: Boolean, default: true }) readonly ripple!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Boolean, default: false }) readonly auto!: boolean
  @Prop({ type: String, default: null }) readonly size!: string
  @Prop({ type: String, default: null }) readonly buttonType!: string
  @Prop({ type: String, default: '' }) readonly icon!: string

  /* Computed Properties */
  get startingBackgroundColor(): string {
    switch (this.theme) {
      case 'blue':
        return '#10c7d5'
      case 'purple':
        return '#f505fc'
    }
    return ''
  }

  get endingBackgroundColor(): string {
    switch (this.theme) {
      case 'blue':
        return '#3c3cc7'
      case 'purple':
        return '#783cc7'
    }
    return ''
  }

  get buttonStyles() {
    switch (this.theme) {
      case 'transparent':
        return {
          backgroundColor: 'transparent',
          border: '1px solid #ffffff'
        }
      default:
        return {
          textShadow: this.shadow ? '0.2rem 0.2rem 0.5rem #998585' : '',
          '--starting-background-color': this.disabled
            ? 'grey'
            : this.startingBackgroundColor,
          '--ending-background-color': this.disabled
            ? 'grey'
            : this.endingBackgroundColor,
          cursor: this.disabled
            ? 'not-allowed'
            : this.noEffect
            ? 'auto'
            : 'pointer'
        }
    }
  }

  /* Emitter */
  onButtonClick() {
    if (this.disabled) return

    this.$emit('click', this)
  }
}
